import { useState, useEffect } from "react";
import { UserCog } from "lucide-react";
import api from "../../services/api";
import ProfileStep1 from "./ProfileStep1";
import ProfileStep2 from "./ProfileStep2";

export default function CompleteProfileModal({ onCompleted }) {
  var formState = useState({
    email: "", phone: "", cpf: "", cnpj: "", birth_date: "", address: "",
    city: "", state: "", cep: "", broker_id: "", new_password: "", confirm_password: "",
  });
  var loadingState = useState(false);
  var brokersState = useState([]);
  var errorState = useState(null);
  var stepState = useState(1);

  useEffect(function() {
    api.get("/clients/brokers-list").then(function(res) {
      brokersState[1](res.data || []);
    }).catch(function() {});
  }, []);

  function updateField(f, v) {
    formState[1](function(p) { var n = {}; for (var k in p) n[k] = p[k]; n[f] = v; return n; });
  }

  async function handleSubmit() {
    var form = formState[0];
    if (stepState[0] === 1) {
      if (!form.email || !form.email.includes("@")) { errorState[1]("Preencha um email valido"); return; }
      stepState[1](2); return;
    }
    if (form.new_password && form.new_password !== form.confirm_password) { errorState[1]("As senhas nao coincidem"); return; }
    if (form.new_password && form.new_password.length < 6) { errorState[1]("Senha deve ter no minimo 6 caracteres"); return; }
    loadingState[1](true); errorState[1](null);
    try {
      var payload = {};
      for (var k in form) { if (k !== "confirm_password" && form[k]) payload[k] = form[k]; }
      await api.post("/clients/complete-profile", payload);
      onCompleted();
    } catch (err) { errorState[1](err.response?.data?.detail || "Erro ao salvar"); }
    finally { loadingState[1](false); }
  }

  var stepLabel = stepState[0] === 1 ? "Dados Pessoais" : "Seguranca";

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4" data-testid="complete-profile-modal">
      <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full max-h-[90vh] overflow-hidden flex flex-col">
        <div className="bg-[#0A2F3D] px-6 py-5 flex items-center gap-3 flex-shrink-0">
          <div className="p-2.5 bg-white/10 rounded-xl"><UserCog className="w-6 h-6 text-[#3B82F6]" /></div>
          <div>
            <h2 className="text-white font-bold text-lg">Complete seu Cadastro</h2>
            <p className="text-white/60 text-xs">Passo {stepState[0]} de 2 - {stepLabel}</p>
          </div>
        </div>
        <div className="p-5 overflow-y-auto flex-1">
          {errorState[0] && <div className="mb-4 px-4 py-2.5 rounded-lg text-sm bg-red-50 text-red-700 border border-red-200">{errorState[0]}</div>}
          {stepState[0] === 1 && <ProfileStep1 form={formState[0]} updateField={updateField} brokers={brokersState[0]} />}
          {stepState[0] === 2 && <ProfileStep2 form={formState[0]} updateField={updateField} />}
        </div>
        <div className="p-5 border-t border-gray-100 flex gap-3 flex-shrink-0">
          {stepState[0] === 2 && (
            <button onClick={function() { stepState[1](1); errorState[1](null); }}
              className="flex-1 px-4 py-2.5 border border-gray-200 rounded-xl text-sm font-medium text-gray-600 hover:bg-gray-50">Voltar</button>
          )}
          <button onClick={handleSubmit} disabled={loadingState[0]}
            className="flex-1 px-4 py-3 bg-[#3B82F6] text-white rounded-xl text-sm font-semibold hover:bg-[#2563EB] disabled:opacity-50"
            data-testid="profile-submit">
            {loadingState[0] ? "Salvando..." : stepState[0] === 1 ? "Proximo" : "Concluir"}
          </button>
        </div>
      </div>
    </div>
  );
}
